import React from 'react'

const LeftAlignmentSvg = (props) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 3H14" stroke={props.color ? props.color : "#7D8492"} stroke-opacity={props.strokeOpacity ? props.strokeOpacity : "0.6"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2 6.33325H8.31333" stroke={props.color ? props.color : "#7D8492"} stroke-opacity={props.strokeOpacity ? props.strokeOpacity : "0.6"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2 9.66675H14" stroke={props.color ? props.color : "#7D8492"} stroke-opacity={props.strokeOpacity ? props.strokeOpacity : "0.6"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2 13H8.31333" stroke={props.color ? props.color : "#7D8492"} stroke-opacity={props.strokeOpacity ? props.strokeOpacity : "0.6"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}
export default LeftAlignmentSvg;
